import { z } from "zod";

import { bosuYokSay } from "./bosDeger";

/**
 * MÜVEKKİL İLETİŞİM KİŞİSİ (CLOS-174 `[121]`).
 *
 * ### ⚠ Üç ayrı kavram
 *
 * Kartın bağımlılık sınırı: *"iletişim kaydı ile KULLANICI HESABI ve TEMSİLCİ YETKİSİ üç
 * ayrı kavramdır."* Bu şema yalnız kişinin KENDİSİNİ tarif ediyor; hesap açma, davet ve
 * temsil yetkisi CLOS-177/178'in işi.
 *
 * ### ⚠ "Temsilci adayı" bir işaret
 *
 * *"Yalnız davet için SEÇİM KOLAYLIĞIDIR."* Bir `boolean` ve hiçbir kapı onu okumuyor.
 */

export const CLIENT_CONTACT_STATUSES = ["active", "inactive"] as const;
export type ClientContactStatus = (typeof CLIENT_CONTACT_STATUSES)[number];

export const CLIENT_CONTACT_STATUS_NAMES: Record<ClientContactStatus, string> = {
  active: "Aktif",
  inactive: "Pasif",
};

const alanlar = {
  fullName: z.string().trim().min(1, "Ad soyad zorunludur").max(200),
  /** Görev/unvan ZORUNLU DEĞİL: her iletişim kişisinin resmî bir unvanı olmuyor. */
  title: bosuYokSay(z.string().trim().max(120).nullish()),
  email: bosuYokSay(z.string().trim().email("Geçerli bir e-posta girin").max(200).nullish()),
  phone: bosuYokSay(z.string().trim().max(40, "Telefon en fazla 40 karakter").nullish()),
  isRepresentativeCandidate: z.boolean().default(false),
};

export const createClientContactSchema = z.strictObject(alanlar);
export type CreateClientContactInput = z.infer<typeof createClientContactSchema>;

/**
 * GÜNCELLEME — sürüm ZORUNLU.
 *
 * ⚠ Kartın *"stale update"* testi bunu istiyor: iki kişi aynı iletişim kaydını düzenlerse
 * ikincinin yazısı ilkini sessizce ezmemeli.
 */
export const updateClientContactSchema = z
  .strictObject({
    version: z.coerce.number().int().min(1),
    fullName: alanlar.fullName.optional(),
    title: alanlar.title,
    email: alanlar.email,
    phone: alanlar.phone,
    isRepresentativeCandidate: z.boolean().optional(),
    /** Pasifleştirme de bir güncelleme: satır SİLİNMİYOR, durumu değişiyor. */
    status: z.enum(CLIENT_CONTACT_STATUSES).optional(),
  })
  .refine((v) => Object.keys(v).some((k) => k !== "version"), {
    message: "En az bir alan güncellenmelidir",
  });
export type UpdateClientContactInput = z.infer<typeof updateClientContactSchema>;

export type ClientContactView = {
  id: string;
  fullName: string;
  title: string | null;
  email: string | null;
  phone: string | null;
  isRepresentativeCandidate: boolean;
  status: string;
  version: number;
  createdByName: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * Olası YİNELEME adayı — uyarı, engel değil.
 *
 * ⚠ Kart: *"aynı kişi için olası duplicate sinyali GÖSTERİLEBİLİR; otomatik birleştirme veya
 * HESAP EŞLEŞTİRME yapılmaz."* Aynı e-postayı iki farklı görev için kaydetmek gerçek bir
 * durum (ortak ofis adresi); engelleseydik kullanıcıyı sahte bir adres uydurmaya iterdik.
 */
export type ClientContactDuplicate = {
  id: string;
  fullName: string;
  matchedOn: "email" | "phone";
};

/** Oluşturma yanıtı: kayıt + varsa yineleme UYARISI (işlem yine de yapıldı). */
export type ClientContactCreated = {
  contact: ClientContactView;
  duplicates: ClientContactDuplicate[];
};

export const CLIENT_CONTACT_ARCHIVED_CLIENT_MESSAGE =
  "Arşivdeki müvekkilin iletişim kişileri düzenlenemez";
export const CLIENT_CONTACT_STALE_MESSAGE =
  "İletişim kaydı siz düzenlerken başkası tarafından güncellendi";
